var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('el-radio-group', {
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.changeLayout
    },
    model: {
      value: (_vm.labelPosition),
      callback: function($$v) {
        _vm.labelPosition = $$v
      },
      expression: "labelPosition"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "left"
    }
  }, [_vm._v("Left")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "center"
    }
  }, [_vm._v("Center")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "right"
    }
  }, [_vm._v("Right")])], 1), _vm._v(" "), _c('div', [_c('el-input-number', {
    attrs: {
      "min": 2,
      "size": "small"
    },
    on: {
      "change": _vm.changeRow
    },
    model: {
      value: (_vm.rowNum),
      callback: function($$v) {
        _vm.rowNum = $$v
      },
      expression: "rowNum"
    }
  }), _vm._v(" "), _c('el-input-number', {
    attrs: {
      "min": 2,
      "size": "small"
    },
    on: {
      "change": _vm.changeCol
    },
    model: {
      value: (_vm.colNum),
      callback: function($$v) {
        _vm.colNum = $$v
      },
      expression: "colNum"
    }
  })], 1), _vm._v(" "), _c('table', [_c('draggable', {
    attrs: {
      "list": _vm.values
    }
  }, _vm._l((_vm.values), function(cells) {
    return _c('tr', _vm._l((cells), function(cell) {
      return _c('td', {
        on: {
          "click": function($event) {
            _vm.selectValue(cell)
          },
          "keyup": function($event) {
            if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
            _vm.submit(cell)
          }
        }
      }, [(!cell.edit) ? _c('div', {
        staticClass: "display",
        domProps: {
          "textContent": _vm._s(cell.text)
        },
        on: {
          "click": function($event) {
            cell.edit = true
          }
        }
      }) : _vm._e(), _vm._v(" "), (cell.edit) ? _c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (cell.text),
          expression: "cell.text"
        }, {
          name: "focus",
          rawName: "v-focus"
        }],
        ref: "textInput",
        refInFor: true,
        attrs: {
          "onkeypress": "this.style.width = ((this.value.length + 1) * 8) + 'px';",
          "onfocus": "this.style.width = ((this.value.length + 1) * 8) + 'px';",
          "type": "text"
        },
        domProps: {
          "value": (cell.text)
        },
        on: {
          "blur": function($event) {
            cell.edit = false
          },
          "keydown": function($event) {
            if (!('button' in $event) && _vm._k($event.keyCode, "tab", 9)) { return null; }
            _vm.nextCell($event)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            cell.text = $event.target.value
          }
        }
      }) : _vm._e()])
    }))
  }))], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "document"
    },
    on: {
      "click": _vm.copyToClipBoard
    }
  }, [_vm._v("Copy to ClipBoard")]), _vm._v(" "), _c('pre', [_vm._v("      "), _c('code', {
    attrs: {
      "id": "mdArea"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.generateMdTable) + "\n      ")]), _vm._v("\n    ")])], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-75c7fafa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = QwGg
// module chunks = 1